import { createSelector } from 'reselect';

export const selectStateNews = () => state => state.news;

export const selectNews = () =>
  createSelector(
    selectStateNews(),
    state => state.news
  );

export const selectNewsSticky = () =>
  createSelector(
    selectStateNews(),
    state => state.newsSticky
  );

export const selectNewsHome = () =>
  createSelector(
    selectStateNews(),
    state => state.news
  );

export const selectFeaturedNew = () =>
  createSelector(
    selectStateNews(),
    state => state.newsHighlight[0]
  );

export const selectNewById = id =>
  createSelector(
    selectStateNews(),
    state => state.newsById[id]
  );

export const selectCurrentPage = () =>
  createSelector(
    selectStateNews(),
    state => state.page
  );

export const selectTotalNews = () =>
  createSelector(
    selectStateNews(),
    state => state.total
  );

export const selectNewsLike = id =>
  createSelector(
    selectStateNews(),
    state => {
      if (!state.newsLike) {
        return false;
      }
      return !!state.newsLike.includes(id);
    }
  );

export const selectNewsFavorite = id =>
  createSelector(
    selectStateNews(),
    state => {
      if (!state.newsFavorite) {
        return false;
      }
      return !!state.newsFavorite.includes(id);
    }
  );

export const selectComments = () =>
  createSelector(
    selectStateNews(),
    state => state.comments
  );

export const selectMoreNews = () =>
  createSelector(
    selectStateNews(),
    state => state.more
  );
